import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import pluralize from 'pluralize';

import ShoppingBasketIcon from '../../../../components/icons/ShoppingBasketIcon';
import Button from '../../../../components/global/Button';

const propTypes = {
  total: PropTypes.number,
  className: PropTypes.string,
  onClick: PropTypes.func,
  to: PropTypes.string,
};

const CartToggle = forwardRef(({ total, className, onClick, to }, ref) => {
  const classes = classNames({
    'btn-cart-toggle': true,
    'btn-cart-toggle-disabled': !total,
    [className]: !!className,
  });

  return (
    <span ref={ref}>
      <Button
        pill
        btnOutline
        btnSize="sm"
        className={classes}
        onClick={onClick}
        to={total > 0 ? to : undefined}
        disabled={!total}
      >
        <div className="badged-icon">
          <ShoppingBasketIcon size={18} color="#0d84fe" className="mr-1" />
          {total > 0 && <div className="red-badge" />}
        </div>

        <span className="d-none d-md-inline-block">
          {pluralize('item', total, true)}
        </span>
      </Button>
    </span>
  );
});

CartToggle.propTypes = propTypes;
CartToggle.displayName = 'CartToggle';

export default CartToggle;
